// extracted by mini-css-extract-plugin
module.exports = {"b1y8e1q1":"b1y8e1q1"};